// CHAT-SWITCH-B (Andrei, 2026-10-28): DE › Overview › Webhooks, for company admins — incoming
// webhooks whose posts wake this DE. Each lands in the admin's DM with the DE (so a person sees
// what came in and what the DE did); the DE is told the text is outside data, never instructions.
// Same panel as a channel's Integrations tab (chat-switch-b.tsx `WebhooksPanel`). Not shown with
// the `chat` add-on off, nor for a DE that is not active.
import { SettingsSection } from "@companyos/ui";
import { WebhookIcon } from "lucide-react";
import type { Api } from "../../api/client";
import type { DeProfile } from "../../api/types";
import { WebhooksPanel } from "../chat/chat-switch-b";
import { type CompanyAccess, isManager } from "../company";
import { useFeature } from "../use-feature";

export function DeWebhooksSection({
  api,
  company,
  de,
}: {
  api: Api;
  company: CompanyAccess;
  de: DeProfile;
}) {
  const chat = useFeature("chat");
  if (!isManager(company) || !chat.enabled || de.status !== "active") return null;
  return (
    <SettingsSection icon={WebhookIcon} title="Webhooks">
      <WebhooksPanel
        chat={{ api, co: company.id, readOnly: chat.readOnly }}
        target={{ kind: "de", id: de.membership_id }}
      />
    </SettingsSection>
  );
}
